document.addEventListener('DOMContentLoaded', () => {
    const fixed_atc_el = document.querySelector('[fixed-add-to-cart]');
    const observed_el = document.querySelector('[product-form-container]');
    const product_details_el = document.querySelector('[product-details]');
    const product_container_el = document.querySelector('.product-container');
    const footer = document.querySelector('footer.footer-section ');

    if (fixed_atc_el && observed_el && product_details_el && footer && product_container_el) {

        // get observed element's width
        let product_details_el_width = product_details_el.offsetWidth;
        let product_container_el_width = product_container_el.offsetWidth;
        let window_width = window.innerWidth;
        let right_position = ((window_width - product_container_el_width) / 2) - 10;
        const right = right_position + 'px';
        fixed_atc_el.style.right = right;

        // Set width of fixed_atc_el to match product_details_el
        fixed_atc_el.style.width = `${product_details_el_width}px`;

        // resize event listener
        window.addEventListener('resize', () => {
            product_details_el_width = product_details_el.offsetWidth;
            fixed_atc_el.style.width = `${product_details_el_width}px`;
            // let main_product_width = main_product.offsetWidth;
            let product_container_el_width = product_container_el.offsetWidth;
            let window_width = window.innerWidth;
            let right_position = ((window_width - product_container_el_width) / 2) - 8;
            const right = right_position + 'px';
            fixed_atc_el.style.right = right;
        });

        fixed_atc_el.addEventListener('click', () => {
            observed_el.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    // If the element is within the specified rootMargin, remove the class
                    fixed_atc_el.classList.remove('visible');
                } else {
                    // If the element is outside the specified rootMargin, add the class
                    fixed_atc_el.classList.add('visible');
                }
            });
        }, {
            rootMargin: '-20% 0px -10% 0px'
        });
        observer.observe(observed_el);
        observer.observe(footer);
    }

    // Read more button to open description accordion
    const readMoreButton = document.querySelector('[product-description] [description-read-more]');
    const productDescriptionAccordion = document.querySelector('[product-information-container] #product-description-accordion');

    if (readMoreButton && productDescriptionAccordion) {
        readMoreButton.addEventListener('click', () => {
          if (!productDescriptionAccordion.classList.contains('active')) {
            productDescriptionAccordion.click();
          }
        });
    }
});
